import Alert from 'react-s-alert';
import { Messages } from '../constants';
import ActionTypes from './ActionTypes';
import { NotificationService } from '../services';
import { CommercialPlanService } from '../services';

export const getStations = () => async dispatch => {
  try {
    dispatch({ type: ActionTypes.GET_STATIONS });
    const stations = await CommercialPlanService.searchStations();
    dispatch({
      type: ActionTypes.GET_STATIONS_SUCCESS,
      payload: stations
    });
  } catch (e) {
    dispatch({ type: ActionTypes.GET_STATIONS_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const clearCommercialPlan = () => async dispatch => {
  dispatch({ type: ActionTypes.CLEAR_COMERCIAL_PLAN });
};

export const updateCommercialPlanType = (type) => async dispatch => {
  dispatch({ type: ActionTypes.UPDATE_COMMERCIAL_PLAN_TYPE, payload: type });
};

export const redirectToRede = () => async dispatch => {
  Alert.info(Messages.MailingInDevelopment);
};

export const getPlans = () => async dispatch => {
  try {
    dispatch({ type: ActionTypes.SHOW_PLANS });
    dispatch({ type: ActionTypes.GET_COMERCIAL_PLAN_PAGED });
    const plans = await CommercialPlanService.searchAll();
    dispatch({
      type: ActionTypes.GET_COMERCIAL_PLAN_PAGED_SUCCESS,
      payload: plans
    });
  } catch (e) {
    dispatch({ type: ActionTypes.GET_COMERCIAL_PLAN_PAGED_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const getPlansStations = (station) => async dispatch => {
  dispatch({ type: ActionTypes.SHOW_PLANS, payload: station });
};

export const loadPlansStations = (station, search) => async dispatch => {
  try {
    dispatch({ type: ActionTypes.GET_COMERCIAL_PLAN_STATION });
    const plans = station._id ? await CommercialPlanService.searchPlanByStations(station) : [];
    dispatch({
      type: ActionTypes.GET_COMERCIAL_PLAN_STATION_SUCCESS,
      payload: plans
    });
    if (search)
      searchPlan(search)(dispatch);
  } catch (e) {
    dispatch({ type: ActionTypes.GET_COMERCIAL_PLAN_STATION_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const getProjects = () => async dispatch => {
  try {
    dispatch({ type: ActionTypes.SHOW_PROJECTS });
    dispatch({ type: ActionTypes.GET_PROJECTS });
    const projects = await CommercialPlanService.searchProjects();
    dispatch({
      type: ActionTypes.GET_PROJECTS_SUCCESS,
      payload: projects
    });
  } catch (e) {
    dispatch({ type: ActionTypes.GET_PROJECTS_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const getProjectsStations = (station) => async dispatch => {
  dispatch({ type: ActionTypes.SHOW_PROJECTS, payload: station });
};

export const loadProjectsStations = (station, search) => async dispatch => {
  try {
    dispatch({ type: ActionTypes.GET_PROJECT_STATION });
    const projects = station._id ? await CommercialPlanService.searchProjectsByStation(station) : [];
    dispatch({
      type: ActionTypes.GET_PROJECT_STATION_SUCCESS,
      payload: projects
    });
    if (search)
      searchProject(search)(dispatch);
  } catch (e) {
    dispatch({ type: ActionTypes.GET_PROJECT_STATION_FAIL });
    NotificationService.showApiResponseErrorAlert(e);
  }
};

export const updateSelectedStation = (station, search) => async dispatch => {
  dispatch({ type: ActionTypes.UPDATE_SELECTED_STATION, payload: station });
  loadProjectsStations(station, search)(dispatch);
  loadPlansStations(station, search)(dispatch);
};

export const searchPlan = (search) => async dispatch => {
  dispatch({ type: ActionTypes.UPDATE_SEARCH_PLAN, payload: search });
  dispatch({ type: ActionTypes.SEARCH_PLAN, payload: search });
};

export const searchProject = (search) => async dispatch => {
  dispatch({ type: ActionTypes.UPDATE_SEARCH_PLAN, payload: search });
  dispatch({ type: ActionTypes.SEARCH_PROJECT, payload: search });
};

export const clearSearch = () => async dispatch => {
  dispatch({ type: ActionTypes.CLEAR_SEARCH });
};


